module.exports = {
  // upc展示类型
  parentTag: 'global-retail-pc',
  // 域名
  domainName: {
    test: 'work-test.i.mi.com',
    pre: 'work-pre.i.mi.com',
    production: 'work.i.mi.com'
  },
  // document.title
  title: '国际零售通PC'
};
